import React from "react";
import { Modal, Box, Typography, Button, Paper } from "@mui/material";
import Swal from "sweetalert2";
import { useAddServiceMutation } from "slices/wellness/doctorSlice";
import { useAddClinicServiceMutation } from "slices/wellness/clinicSlice";
import { useGetCategoriesQuery } from "slices/beautyApp/categorySlice";
import { IMAGE_URL } from "network";
import { useLinkCategoryMutation } from "slices/beautyApp/beauticianSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

function ServicesModal({ open, data, usertype, onClose }) {
  const [saveCategory] = useLinkCategoryMutation();
  const { data: service, isLoading } = useGetCategoriesQuery({});

  const handleSelect = async (categoryId) => {
    try {
   
      let response = await saveCategory({
        user_id: data?._id,
        category: categoryId, // send array of selected services
      });

      if (!response?.data?.data) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Services upadated successfully",
        });
      }

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Service Updated",
          text: "Category successfully assigned.",
        });
        onClose();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.data?.message || error?.message || "Server error",
      });
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Update Services
        </Typography>

        <Box
          display="flex"
          flexWrap="wrap"
          gap={2}
          justifyContent="center"
          mb={3}
        >
          {!isLoading &&
            service?.data?.map((item) => {
              if (item.module_type !== "independent") return null;

              return (
                <Paper
                  key={item._id}
                  onClick={() => handleSelect(item._id)} // ✅ hit API directly
                  sx={{
                    width: 120,
                    padding: 2,
                    textAlign: "center",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                    transition: "all 0.3s",
                    "&:hover": {
                      border: "2px solid #1976d2",
                      backgroundColor: "#e3f2fd",
                    },
                  }}
                >
                  <Box
                    component="img"
                    crossOrigin="anonymous"
                    src={`${IMAGE_URL}${item.image}`}
                    alt={item.title}
                    sx={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      mb: 1,
                    }}
                  />
                  <Typography variant="subtitle2">{item.name}</Typography>
                </Paper>
              );
            })}
        </Box>

        <Box mt={4} display="flex" justifyContent="center" gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default ServicesModal;
